define(["data/config"], function(config) {
    require("vendor/jquery.dropdown");
    require("vendor/jquery.select");

    let dates = null;

    var initForm = function($element)
    {
        $($element).find('[data-dropdown]').ebDropdown();
        $($element).find('select').ebSelect();

        $('[data-select-fancy]')
        .on('blur change', 'select', (e) => {
            $(e.delegateTarget).removeClass('is-focus')
        })
        .on('focus', 'select', (e) => {
            $(e.delegateTarget).addClass('is-focus')
        });

        $('[data-input-fancy]')
        .on('blur', 'input', (e) => {
            $(e.delegateTarget).removeClass('is-focus')
        })
        .on('focus', 'input', (e) => {
            $(e.delegateTarget).addClass('is-focus')
        });
    };

    var meetingTypeChange = function(e, value, label) {
        $('#wizard-inputMeetingTypeLabel').val(label)
        dates = JSON.parse($(`[data-dropdown-value='${value}']`, $('#wizard-meetingType')).attr('data-dropdown-dates'))
        setDates();
    };

    var setDates = function() {
        $('#wizard-inputDate').empty()

        for (let key in dates) {
            $('#wizard-inputDate').append($(`<option value="${key}">${dates[key].label}</option>`))
        }

        $('#wizard-inputDate')
            .prop('disabled', (dates.length === 0))
            .triggerHandler('change')
    };

    var dateChange = function(e, value, label) {
        let date
        let disabled

        $('#wizard-inputDateLabel').val(label)

        if (dates.hasOwnProperty(value)) {
            date = dates[value]
            $('#wizard-inputTime')
                .empty()
                .append($(`<option value="">&mdash;</option>`))

            for (let key in date.slots) {
                disabled = !date.slots[key]
                $('#wizard-inputTime')
                    .append($(`<option value="${key}">${key}</option>`)
                    .prop('disabled', disabled))
            }

            $('#wizard-inputTime').prop('disabled', (date.slots.length === 0)).triggerHandler('change')
        }
    };

    var timeChange = function(e, value, label) {
        $('#wizard-buttonSubmitStep1').prop('disabled', (value === ''))
    };

    var apply = function($element) {
        initForm($element);

        $('#wizard-meetingType').on('ebDropdown:change', meetingTypeChange.bind(this));
        $('#wizard-inputDate').on('ebSelect:change', dateChange.bind(this))
        $('#wizard-inputTime').on('ebSelect:change', timeChange.bind(this))
    };

    return {
        name: "exhibitorMeetingForm",
        apply: apply
    };
});